import * as Api from '@/api';
import tableHeaderName from '@/utils/table_header_name';
import DeleteStatementModal from '@/components/Modals/DeleteStatementModal';
import { _restApiDataFormatting } from '@/utils/_function.js';
import { mapState } from 'vuex';

export default {
  name: 'StatementDetail',
  data() {
    return {
      statementDetail: null,
      history: [],
      statementId: null,
      claimLinks: [],
      state: 'Новое',
      fields: [
        {
          key: 'number',
          label: '№'
        },
        {
          key: 'url',
          label: 'URL'
        },
        {
          key: 'state',
          label: 'Статус'
        },
        {
          key: 'btn',
          label: 'Подтвердить нарушение'
        }
      ],
      historyFields: tableHeaderName.historyFields
    };
  },
  mounted() {
    this.getStatementDetailData();
  },
  computed: {
    getStatementDetailLoaderStatus() {
      return this.$store.getters.LOADERS.includes('statement');
    },
    ...mapState({
      authUser: state => state.authUser
    })
  },
  methods: {
    sort(arr) {
      if (!Array.isArray(arr) || !arr.length) {
        return [];
      }

      return arr.sort(function(a, b) {
        return a.id - b.id;
      });
    },
    getStatementDetailData() {
      this.statementId = this.$route.params.id;
      const blocker = 'statement';

      Api.getStatementsDetailData(this.statementId, blocker)
        .then((response) => {
          if (response) {
            this.statementDetail = _restApiDataFormatting(response);
          }

          this.statementDetail.claimLinks = this.sort(this.statementDetail.claimLinks);

          if (
            this.statementDetail.contents.legalLinks &&
            this.statementDetail.contents.legalLinks.length > 0) {
            this.statementDetail.contents.legalLinks = this.statementDetail.contents.legalLinks.map((item) => {
              return item.url;
            });
          }

          this.claimLinks.map((item) => {
            if (
              item.url.indexOf('https') < 0 &&
              item.url.indexOf('http') < 0
            ) {
              item.url = 'http://' + item.url;
            }

            return item;
          });

          this.claimLinks = [...this.claimLinks];
        })
        .catch((error) => {
          if (error) {
            this.$rollbar.warning(error);
          }
          this.$toastr('error', this.$t('commonMessage.requestError'), 'Ошибка');
        });
    },

    editStatement() {
      this.$router.push({ path: `/statement-edit/${this.statementId}` });
    },

    beforeOpenModal() {
      const body = document.body;
      body.style.overflow = 'hidden';
    },

    beforeCloseModal() {
      const body = document.body;
      body.style.overflow = 'auto';
    },

    deleteStatement(statementId) {
      const id = statementId;
      this.$modal.show(DeleteStatementModal, {
        id
      },
      {
        width: 476,
        height: 'auto',
        adaptive: true,
        resizable: false,
        clickToClose: false
      }, {
        'before-open': this.beforeOpenModal,
        'before-close': this.beforeCloseModal
      });
    },

    rowClass(item) {
      if (!item) {
        return;
      }

      if (item.state === 'rejected') {
        return 'table--reject';
      }

      if (item.state === 'accept') {
        return 'table--accept';
      }
    }
  }
};
